import React, { useState, useEffect } from "react";

const AuthContext = React.createContext({
  isLoggedIn: false,
  onLogout: () => {},
  inLogin: (email, password) => {},
  actueleUrl: "/",
  onClickUrl: () => {},
});

export const AuthContextProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [actueleUrl, setActueleUrl] = useState("/");

  useEffect(() => {
    const storedUserLoggedInInformation = localStorage.getItem("isLoggedIn");

    if (storedUserLoggedInInformation === "1") {
      setIsLoggedIn(true);
    }
  }, []);

  const loginHandler = async function(email, password) {
    console.log("Email: " + email);
    console.log("Password: " + password);

    const response = await fetch(
      "https://www.marchouben.nl/php/inloggegevens-post.php",
      {
        method: "POST",
        body: JSON.stringify({ email: email, password: password }),
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    const data = await response.json();
    console.log(data);

    localStorage.setItem("Email", email);
    localStorage.setItem("Password", password);
    localStorage.setItem("isLoggedIn", "1");
    setIsLoggedIn(true);
    setActueleUrl("/home");
  };

  const logoutHandler = () => {
    localStorage.removeItem("Email");
    localStorage.removeItem("Password");
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
    setActueleUrl("/login");
  };

  const urlHandler = (url) => {
    console.log("urlHandler: " + url);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        onLogout: logoutHandler,
        onLogin: loginHandler,
        actueleUrl: actueleUrl,
        onClickUrl: urlHandler,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;